package com.patronat.top.client.presentation.home.components

import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.VenueSectionTitleText

@Composable
fun HomeSectionHeader(
    title: String,
    modifier: Modifier = Modifier
) {
    Text(
        text = title,
        style = VenueSectionTitleText.copy(
            color = MineShaft900,
            fontSize = 20.sp,
            lineHeight = 30.sp,
            letterSpacing = (-0.45).sp,
            fontWeight = FontWeight.Medium
        ),
        modifier = modifier
    )
}
